import { createReducer, on } from '@ngrx/store';
import { IQueryResult } from '@pmis3/data-access';

import {
    LoadFail,
    LoadSuccess,
    LoadVesselSchedulesByDateRange,
} from '../actions/vesselSchedule.action';
import { VesselSchedule } from '../';
import { IDateTimeRange } from '@pmis3/utils';
export const vesselScheduleFeatureKey = 'vesselSchedule';

export enum VesselScheduleStateStatus {
    LOADING = 'loading',
    FAILED = 'failed',
    PENDING = 'pending',
    SUCCESS = 'success',
}
export interface VesselScheduleState {
    vesselSchedules: IQueryResult<VesselSchedule>;
    dateRange?: IDateTimeRange;
    error?: string;
    status: VesselScheduleStateStatus;
}

export const initialState: VesselScheduleState = {
    vesselSchedules: {
        query: { pageIndex: 0, pageSize: 0 },
        items: [],
        totalCount: 0,
    },
    status: VesselScheduleStateStatus.PENDING,
};

export const vesselScheduleReducer = createReducer(
    initialState,
    on(LoadVesselSchedulesByDateRange, (state, action) => ({
        ...state,
        dateRange: action.dateRange,
        status: VesselScheduleStateStatus.LOADING,
    })),
    on(LoadSuccess, (state, { result: vesselSchedules }) => ({
        ...state,
        vesselSchedules,
        status: VesselScheduleStateStatus.SUCCESS,
    })),
    // on(LoadFirstSchedules, (state, { result: firstStopsIdList }) => ({ ...state, firstStopsIds: VesselScheduleHelper.findFirstSchedules(vesselSchedules.items), status: VesselScheduleStateStatus.SUCCESS })),
    on(LoadFail, (state, { error }) => ({
        ...state,
        error,
        status: VesselScheduleStateStatus.FAILED,
    }))
);
